import React from 'react'
import Avatar from '@mui/material/Avatar';
import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';
import { Typography, Link } from '@mui/material';

function Author() {
  return (
    <div>
        <Stack direction="row" spacing={1}>
        <Typography variant='h5'>Made with 💙 By</Typography>
        <Link href="https://arjun.guru" target="_blank">
            <Chip
                avatar={<Avatar alt="Arjun" src="https://pbs.twimg.com/profile_images/1436673732043427842/mSoW-9bU_400x400.jpg" />}
                label="Arjun"
                variant="outlined"
            />
        </Link>
        </Stack>
    </div>
  )
}

export default Author